import React from 'react';
import why1Img from '../assets/why1.jpeg';
import why2Img from '../assets/why2.jpeg';
import why3Img from '../assets/why3.jpeg';
import why4Img from '../assets/why4.jpeg';
import why5Img from '../assets/why5.jpeg';
import why6Img from '../assets/why6.jpeg';
import why7Img from '../assets/why7.jpeg';
import why8Img from '../assets/why8.jpeg';
import why9Img from '../assets/why9.jpeg';
import why10Img from '../assets/why10.jpeg';
import why11Img from '../assets/why11.jpeg';
import why12Img from '../assets/why12.jpeg';
import why13Img from '../assets/why13.jpeg';
import why14Img from '../assets/why14.jpeg';
import '../styles/pages.css';

function WhyChooseUs() {
  const reasons = [
    { title: 'Personalized Solutions', text: 'We understand that every business is unique. Our solutions are tailored to meet your specific requirements and challenges.', img: why1Img },
    { title: 'Faster Decision-Making', text: 'As a growing company, we offer agility and quick response times that larger corporations can\'t match.', img: why2Img },
    { title: 'Direct Leadership Involvement', text: 'Work directly with our leadership team who are investing continuously in your success and understand your business needs.', img: why3Img },
    { title: 'Scalable & Secure Architecture', text: 'Enterprise-grade security and infrastructure that grows with your business needs.', img: why4Img },
    { title: 'Long-Term Partnership', text: 'We\'re partners committed to your long-term success and growth.', img: why5Img },
    { title: 'Technology-Driven Mindset', text: 'We stay ahead of technology trends to provide you with innovative and future-ready solutions.', img: why6Img },
    { title: 'Startup Agility', text: 'Fast decision-making and flexible solutions tailored to your needs', img: why7Img },
    { title: 'Customer-First Approach', text: 'Your success is our priority with personalized service', img: why8Img },
    { title: 'Proven Expertise', text: 'Latest innovations combined with proven expertise and industry experience', img: why9Img },
    { title: 'Implementation & Deployment', text: 'Seamless implementation and deployment of IT solutions with minimal disruption to your operations', img: why10Img },
    { title: 'Continuous Optimization', text: 'Ongoing monitoring and optimization to ensure peak performance and efficiency', img: why11Img },
    { title: 'Solution Design', text: 'Custom-designed solutions that align with your business objectives and technical requirements', img: why12Img },
    { title: 'Training & Support', text: 'Comprehensive training and Quick support to empower your team and ensure smooth operations', img: why13Img },
    { title: 'Consultation & Assessment', text: 'Expert consultation and thorough assessment to identify the best technology strategies for your business', img: why14Img }
  ];

  return (
    <div>
      <section className="hero">
        <div className="container">
          <h1>Why Choose Integritz</h1>
          <p>Your trusted IT infrastructure partner</p>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="why-grid">
            {reasons.map((reason, index) => (
              <div key={index} className="why-card">
                <img src={reason.img} alt={reason.title} className="why-card-img" />
                <div className="why-card-content">
                  <h3>{reason.title}</h3>
                  <p>{reason.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="section" style={{background: 'var(--light)'}}>
        <div className="container">
          <h2 className="section-title">Experience & Expertise</h2>
          <p className="centered-text">
            Backed by over 35 years of distinguished industry experience,
            our leadership brings strategic insight and deep technical proficiency 
            in delivering enterprise-grade IT solutions. We architect and implement 
            robust, scalable, and future-ready technology infrastructures that empower 
            organizations to innovate and operate with confidence.
          </p>
          <br/>
          <p className="centered-text">
            As a newly established organisation, it is led by a founder with over 35 years
            of industry expertise and a proven track record of working with globally recognized
            organizations such as Infosys, BPL, First American Corporation Pvt. Ltd., 
            APC (American Power Conversion), First Indian Corporation, General Electric, 
            ChinaSoft International Limited, ZEISS, ISRO, LRDE, ADA (Aeronautical Development Agency),
            ADE (Aeronautical Development Establishment), GTRE and Schneider Electric, etc,.
          </p>
          <br/>
          <p className="centered-text">
            Our expertise spans IT infrastructure, data centers, cloud solutions, 
            enterprise systems, and technology consulting—ensuring secure, 
            high-performance environments tailored to complex business needs.
            This breadth of experience reflects our commitment to excellence, 
            reliability, and delivering measurable business value through technology.
          </p>
        </div>
      </section>
    </div>
  );
}

export default WhyChooseUs;
